class CompositionSection {
  constructor(section) {
    this.section = section;
    this.hasPack = this.section.dataset.hasPack === 'true';
    this.tabs = [];
    this.navigationSwiper = null;
    this.currentIndex = 0;

    this.init();
  }

  init() {
    console.log('[Composition] Init, hasPack:', this.hasPack);

    this.initNutritionToggles();

    if (!this.hasPack) {
      console.log('[Composition] No pack, skipping init');
      return;
    }

    this.tabs = Array.from(this.section.querySelectorAll('.section-composition__tab'));
    console.log('[Composition] Found tabs:', this.tabs.length);

    if (this.tabs.length === 0) {
      console.log('[Composition] No tabs found, skipping init');
      return;
    }

    // Initialize slides
    this.initSlides();

    // Check if navigation needs slider
    this.initNavigationIfNeeded();

    // Add click handlers to tabs
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        this.goToSlide(index);
      });
    });

    // Set initial product visuals
    this.updateProductVisuals(0);
  }

  initNavigationIfNeeded() {
    const navigationContainer = this.section.querySelector('[data-navigation-container]');
    const tabsWrapper = this.section.querySelector('.section-composition__tabs-wrapper');

    if (!navigationContainer || !tabsWrapper) return;

    // Vérifier si les tabs débordent
    const containerWidth = navigationContainer.offsetWidth - 16; // padding 8px * 2
    const tabsWidth = Array.from(this.tabs).reduce((total, tab) => {
      return total + tab.offsetWidth + 6; // gap de 6px
    }, 0);

    console.log('[Composition] Container width:', containerWidth);
    console.log('[Composition] Tabs total width:', tabsWidth);

    if (tabsWidth > containerWidth) {
      console.log('[Composition] Overflow detected, initializing Swiper');
      this.initNavigationSwiper();
    } else {
      console.log('[Composition] No overflow, normal flex layout');
    }
  }

  initNavigationSwiper() {
    const navigationContainer = this.section.querySelector('[data-navigation-container]');
    if (!navigationContainer) return;

    navigationContainer.classList.add('swiper');

    this.navigationSwiper = new Swiper(navigationContainer, {
      slidesPerView: 'auto',
      freeMode: true,
      pagination: {
        el: this.section.querySelector('.section-composition__swiper-pagination'),
        clickable: true,
      },
    });

    console.log('[Composition] Navigation Swiper initialized');
  }

  initSlides() {
    const sliderEl = this.section.querySelector('.section-composition__slider');
    if (!sliderEl) {
      console.error('[Composition] No slider element found');
      return;
    }

    const slides = Array.from(sliderEl.querySelectorAll('.section-composition__slide'));
    console.log('[Composition] Found slides:', slides.length);

    // Show first slide
    slides.forEach((slide, index) => {
      if (index === 0) {
        slide.classList.add('section-composition__slide--active');
      } else {
        slide.classList.remove('section-composition__slide--active');
      }
    });
  }

  goToSlide(index) {
    console.log('[Composition] goToSlide called with index:', index);

    const slides = Array.from(this.section.querySelectorAll('.section-composition__slide'));
    console.log('[Composition] Found slides:', slides.length);

    slides.forEach((slide, i) => {
      if (i === index) {
        console.log('[Composition] Activating slide', i);
        slide.classList.add('section-composition__slide--active');
      } else {
        console.log('[Composition] Deactivating slide', i);
        slide.classList.remove('section-composition__slide--active');
      }
    });

    this.updateActiveStates(index);
    this.updateProductVisuals(index);
  }

  updateActiveStates(index) {
    this.currentIndex = index;

    // Update tabs
    this.tabs.forEach((tab, i) => {
      if (i === index) {
        tab.classList.add('section-composition__tab--active');
      } else {
        tab.classList.remove('section-composition__tab--active');
      }
    });
  }

  initNutritionToggles() {
    const toggles = this.section.querySelectorAll('.section-composition__nutrition-toggle');
    if (toggles.length === 0) return;

    toggles.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const nutrition = toggle.closest('.section-composition__nutrition');
        const target = toggle.dataset.nutritionTarget;

        nutrition.querySelectorAll('.section-composition__nutrition-toggle').forEach((t) => {
          t.classList.remove('section-composition__nutrition-toggle--active');
        });
        toggle.classList.add('section-composition__nutrition-toggle--active');

        nutrition.querySelectorAll('.section-composition__nutrition-table').forEach((panel) => {
          panel.classList.toggle('section-composition__nutrition-table--active', panel.dataset.nutritionPanel === target);
        });
      });
    });
  }

  updateProductVisuals(index) {
    const slides = Array.from(this.section.querySelectorAll('.section-composition__slide'));
    const activeSlide = slides[index];

    if (!activeSlide) {
      console.error('[Composition] No slide found at index', index);
      return;
    }

    // Update container background color
    const container = this.section.querySelector('.section-composition__container');
    const productColor = activeSlide.dataset.productColor;

    if (container && productColor) {
      console.log('[Composition] Updating container color to:', productColor);
      container.style.backgroundColor = productColor;
    }

    // Update decorative images
    for (let i = 1; i <= 6; i++) {
      const floatingUrl = activeSlide.dataset[`floating-${i}`];
      const decorationEl = this.section.querySelector(`.section-composition__decoration--${i}`);

      if (decorationEl) {
        const img = decorationEl.querySelector('img');

        if (floatingUrl && floatingUrl.trim() !== '') {
          // Show decoration and update image
          decorationEl.style.display = '';
          if (img) {
            img.src = floatingUrl;
          }
          console.log(`[Composition] Updated floating image ${i} to:`, floatingUrl);
        } else {
          // Hide decoration if no image
          decorationEl.style.display = 'none';
          console.log(`[Composition] Hiding floating image ${i} (no URL)`);
        }
      }
    }
  }

}

// Initialize all composition sections
document.addEventListener('DOMContentLoaded', () => {
  console.log('[Composition] DOMContentLoaded');
  const sections = document.querySelectorAll('[data-section-type="w-composition"]');
  console.log('[Composition] Found sections:', sections.length);
  sections.forEach((section) => {
    console.log('[Composition] Initializing section:', section);
    new CompositionSection(section);
  });
});

// Shopify Section Events
if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('[data-section-type="w-composition"]')) {
      new CompositionSection(event.target.querySelector('[data-section-type="w-composition"]'));
    }
  });
}
